import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../../mensajes';
import { Dimmer } from "../../spinner";
import axios from "axios";
import {
    validaSoloNumero,
} from '../../../util/varios';
import CatalogoActividadEconomica from '../../../catalogos/catalogoActividadEconomica';
import CatalogoComercio from '../../../catalogos/catalogoComercio';
import { height } from '@mui/system';

export const ImpDejuradasAnual = (props) => {
    let token = localStorage.getItem("jwtToken");

    /* Variables de estados */
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const btnSalir = useRef();
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [msg, setMsg] = useState();
    const [mostrar2, setMostrar2] = useState(false);
    const [titulo2, setTitulo2] = useState();
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [contar1, setContar1] = useState(0);
    const [anio, setAnio] = useState([]);
    const [visibleF, setVisibleF] = useState('collapse');
    const [visibleA, setVisibleA] = useState('hidden');
    const [mostrarCatalogo, setMostrarCatalogo] = useState(false);

    // Estados para los valores seleccionados
    const [selectedAnio, setSelectedAnio] = useState('');
    const [activate, setActivate] = useState(false);

    // Estado para almacenar las declaraciones
    const [declaraciones, setDeclaraciones] = useState([]);

    // Estado para almacenar los datos del comercio
    const [comercio, setComercio] = useState({
        rif: '',
        idcomercio: '',
        nombre: '',
        direccion: ''
    });

    // Referencias para inputs y textareas
    const txtCedRif = useRef('');
    const txtCod = useRef('');
    const txtRazon = useRef('');
    const txtDirec = useRef('');
    const cmbAnio = useRef();

    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
        setFechaSistema(obj.fechasistema);
        var nanio = []
        var aini = parseInt(obj.anioactu) - 7;
        var afin = parseInt(obj.anioactu);
        for (let i = 1; i <= afin - aini; i++) {
            nanio.push({ anio: afin + 1 - i });
        }
        setAnio(nanio);

        // Establecer año actual como seleccionado por defecto
        if (nanio.length > 0) {
            setSelectedAnio(nanio[0].anio.toString());
        }

        // Si se recibe un comercio como prop, cargarlo
        if (props.comercio) {
            setComercio({
                rif: props.comercio.rif || '',
                idcomercio: props.comercio.idcomercio || props.comercio.codcomercio || '',
                nombre: props.comercio.nombre || '',
                direccion: props.comercio.direccion || ''
            });

            // Si ya tenemos un año seleccionado, cargar las declaraciones
            if (nanio.length > 0) {
                consultarDjuradas(
                    props.comercio.idcomercio || props.comercio.codcomercio,
                    nanio[0].anio.toString()
                );
            }
        }
    }, [props.comercio]);

    let op = require('../../../../src/modulos/datos');

    const consultarDjuradas = (id, anio) => {
        if (!id) {
            setMensaje({
                mostrar: true,
                titulo: 'ERROR',
                texto: 'Debe seleccionar un comercio',
                icono: 'error'
            });
            return;
        }

        setActivate(true);
        setDeclaraciones([]); // Limpiar tabla antes de cargar nuevos datos

        // Construir la URL con los parámetros seleccionados
        let endpoint = `${op.conexion}/api/industria/djuradacomercioanual?idcomercio=${id}&anio=${anio}`;

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                // Guardar los datos de las declaraciones
                setDeclaraciones(response.data);
            }
            setActivate(false);
        }).catch(function (error) {
            setMensaje({
                mostrar: true,
                titulo: 'ERROR',
                texto: error.response?.data?.message || 'Error al consultar declaraciones',
                icono: 'error'
            });
            setActivate(false);
        });
    };

    const imprimirReporte = () => {
        // Validar que se hayan cargado datos
        if (declaraciones.length === 0) {
            setMensaje({
                mostrar: true,
                titulo: 'ERROR',
                texto: 'No hay datos para imprimir',
                icono: 'error'
            });
            return;
        }

        setActivate(true);

        // Aquí iría la lógica para generar el reporte
        console.log("Generando reporte con datos:", declaraciones);

        // Simulación de generación de reporte
        setTimeout(() => {
            setMensaje({
                mostrar: true,
                titulo: 'ÉXITO',
                texto: 'Reporte generado correctamente',
                icono: 'success'
            });
            setActivate(false);
        }, 1500);
    };

    const cancelar = () => {
        txtCedRif.current.value = ''
        txtCod.current.value = ''

        txtRazon.current.value = ''
        txtDirec.current.value = ''

        setDeclaraciones([]);
    }

    const salir = (e) => {
        e.preventDefault();
        txtCedRif.current.value = ''
        txtCod.current.value = ''

        txtRazon.current.value = ''
        txtDirec.current.value = ''

        setDeclaraciones([]);
        props.setShow();
        props.setTabla();

    }

    const seleccionarComercio = (codigo) => {
        let campos = "*";
        let nomtab = "comercio";
        let nomid = "idcomercio";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`;

        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.idcomercio > 0) {
                        // Actualizar el estado del comercio
                        setComercio({
                            rif: response.data.rif,
                            idcomercio: response.data.idcomercio,
                            nombre: response.data.nombre,
                            direccion: response.data.direccion
                        });

                        // Consultar las declaraciones del comercio para el año seleccionado
                        consultarDjuradas(response.data.idcomercio, selectedAnio);
                    } else {
                        setMensaje({
                            mostrar: true,
                            titulo: "Error.",
                            texto: "¡Código i/o Comercio, No esta Registrado!",
                            icono: "error",
                        });
                        // Limpiar el formulario
                        setComercio({
                            rif: '',
                            idcomercio: '',
                            nombre: '',
                            direccion: ''
                        });
                        setDeclaraciones([]);
                    }
                }
                setActivate(false);
            })
            .catch((error) => {
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response?.data?.message || 'Error al consultar comercio',
                    icono: "error",
                });
                setActivate(false);
            });
    };

    const datosClasificador = (id, nombre, codCat, repreLegal) => {
        console.log(id, nombre.trim(), repreLegal.trim());
        seleccionarComercio(id);
        setMostrarCatalogo(false);
    };

    const handleCmbAnio = (e) => {
        const anioSeleccionado = e.target.value;
        setSelectedAnio(anioSeleccionado);
        var codigo = txtCod.current.value;
        
        // Validar que haya un código de comercio seleccionado
        if (!codigo || codigo.trim() === '') {
            setMensaje({
                mostrar: true,
                titulo: 'ADVERTENCIA',
                texto: 'Debe seleccionar un comercio antes de consultar',
                icono: 'warning'
            });
            return;
        }
        
        consultarDjuradas(codigo, anioSeleccionado);
    };
    // Función para formatear números como moneda
    const formatCurrency = (value) => {
        return parseFloat(value || 0).toFixed(2).replace('.', ',');
    };

    // Función para obtener el nombre del tipo de declaración
    const getTipoDeclaracion = (tipo) => {
        switch (tipo) {
            case 1: return 'Definitiva';
            case 2: return 'Regular';
            case 3: return 'Quincenal';
            case 4: return 'Estimada';
            default: return 'Desconocido';
        }
    };

    // Función para formatear fecha
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString();
    };


    const imprimirDeudaGeneral = () => {
        var idcomercio = txtCod.current.value;
        
        // Validar que haya un código de comercio seleccioncomercio || idcomado
        if (!idcomercio.trim() === '') {
            setMensaje({
                mostrar: true,
                titulo: 'ADVERTENCIA',
                texto: 'Debe seleccionar un comercio antes de imprimir',
                icono: 'warning'
            });
            return;
        }
        
        var reporte = 'DeclaracionContri2';
        var condicion = `dj.idcomercio = ${idcomercio} `;
        window.open(op.reportes + "/actividadeconomica?" + "reporte=" + reporte + "&CONDICION=" + condicion, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setContar1(0);
            }}
        >
            <Modal.Header className='azulGradiant'>
                Imprimir Deuda Juradas Anuales
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={salir}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap px-0 row">
                <div className="col-md-12 row mx-auto px-0"  >

                    <div className="input-group input-group-sm col-md-4 col-sm-12 mb-1">
                        <div className="input-group-prepend">
                            <span className="input-group-text"><i className="fas fa-id-card"></i>Ced/Rif:</span>
                        </div>
                        <input
                            type="text"
                            className="form-control text-uppercase"
                            ref={txtCedRif}
                            disabled
                            value={comercio.rif}
                        />
                    </div>
                    <div className="input-group input-group-sm col-md-4 mb-1"></div>
                    <div className="input-group input-group-sm col-md-4 mb-1">
                        <div className="input-group-prepend">
                            <span className="input-group-text"><i className="fas fa-cod"></i>Código:</span>
                        </div>
                        <input
                            type="text"
                            className="form-control text-uppercase"
                            ref={txtCod}
                            value={comercio.idcomercio}
                        />
                        <div className="input-group-append">
                            <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={() => setMostrarCatalogo(true)}
                            >
                                <i className="fas fa-search"></i>
                            </button>
                        </div>
                    </div>
                    <div className="input-group input-group-sm col-md-12 mb-1">
                        <div className="input-group-prepend">
                            <span className="input-group-text"><i className="fas fa-building"></i>Razon Social:</span>
                        </div>
                        <input
                            type="text"
                            className="form-control text-uppercase"
                            ref={txtRazon}
                            disabled
                            value={comercio.nombre}
                        />
                    </div>
                    <div className="input-group input-group-sm col-md-12 mb-1">
                        <div className="input-group-prepend">
                            <span className="input-group-text"><i className="fas fa-building"></i>Direccion:</span>
                        </div>
                        <textarea
                            type="textarea"
                            className="form-control text-uppercase"
                            ref={txtDirec}
                            style={{ height: 40 }}
                            disabled
                            value={comercio.direccion}
                        />
                    </div>
                </div>


                {/* Selector de año */}
                <div className="input-group input-group-sm col-md-3 mb-1">
                    <span className="input-group-text">Año:</span>
                    <select
                        ref={cmbAnio}
                        className="form-select form-select-sm"
                        onChange={handleCmbAnio}
                        value={selectedAnio}
                    >
                        {anio.map(a => (
                            <option key={a.anio} value={a.anio.toString()}>{a.anio}</option>
                        ))}
                    </select>
                </div>
                <div className='col-md-9 mb-1'></div>

                {/* Vista para escritorio - Tabla */}
                <div className="col-12 mt-3 d-none d-md-block">
                    <h5>Declaraciones Juradas</h5>
                    {declaraciones.length > 0 ? (
                        <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            <table className="table table-striped table-hover table-sm border-table">
                                <thead className="sticky-top text-white text-center fw-bold ">
                                    <tr className='azulGradiant'>
                                        <th>Mes</th>
                                        <th>Tipo</th>
                                        <th>Fecha Declaración</th>
                                        <th>Monto Declarado</th>
                                        <th>Monto a Pagar</th>
                                        <th>Recargo</th>
                                        <th>Interés</th>
                                        <th>Multa</th>
                                        <th>Retenciones</th>
                                        <th>Estado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {declaraciones.map((dec, index) => (
                                        <tr key={index}>
                                            <td>{dec.mes}</td>
                                            <td>{getTipoDeclaracion(dec.tipo)}</td>
                                            <td>{formatDate(dec.fechadeclaracion)}</td>
                                            <td className="text-right">{formatCurrency(dec.montodeclarado)}</td>
                                            <td className="text-right">{formatCurrency(dec.montoapagar)}</td>
                                            <td className="text-right">{formatCurrency(dec.recargo)}</td>
                                            <td className="text-right">{formatCurrency(dec.interes)}</td>
                                            <td className="text-right">{formatCurrency(dec.multa)}</td>
                                            <td className="text-right">{formatCurrency(dec.retenciones)}</td>
                                            <td>
                                                {dec.pagada ?
                                                    <span className="badge badge-success">Pagada</span> :
                                                    <span className="badge badge-danger">Pendiente</span>
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot className="thead-dark">
                                    <tr>
                                        <td colSpan="3" className="text-right"><strong>Totales:</strong></td>
                                        <td className="text-right">
                                            <strong>{formatCurrency(
                                                declaraciones.reduce((sum, dec) => sum + parseFloat(dec.montodeclarado || 0), 0)
                                            )}</strong>
                                        </td>
                                        <td className="text-right">
                                            <strong>{formatCurrency(
                                                declaraciones.reduce((sum, dec) => sum + parseFloat(dec.montoapagar || 0), 0)
                                            )}</strong>
                                        </td>
                                        <td className="text-right">
                                            <strong>{formatCurrency(
                                                declaraciones.reduce((sum, dec) => sum + parseFloat(dec.recargo || 0), 0)
                                            )}</strong>
                                        </td>
                                        <td className="text-right">
                                            <strong>{formatCurrency(
                                                declaraciones.reduce((sum, dec) => sum + parseFloat(dec.interes || 0), 0)
                                            )}</strong>
                                        </td>
                                        <td className="text-right">
                                            <strong>{formatCurrency(
                                                declaraciones.reduce((sum, dec) => sum + parseFloat(dec.multa || 0), 0)
                                            )}</strong>
                                        </td>
                                        <td className="text-right">
                                            <strong>{formatCurrency(
                                                declaraciones.reduce((sum, dec) => sum + parseFloat(dec.retenciones || 0), 0)
                                            )}</strong>
                                        </td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    ) : (
                        <div className="alert alert-info mt-2">
                            No hay declaraciones para mostrar. Seleccione un comercio y un año.
                        </div>
                    )}
                </div>

                {/* Vista para móvil - Tarjetas */}
                <div className="col-12 mt-3 d-md-none">
                    <h5>Declaraciones Juradas</h5>
                    {declaraciones.length > 0 ? (
                        <div className="accordion" id="declaracionesAccordion" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {declaraciones.map((dec, index) => (
                                <div key={index} className="card mb-2">
                                    <div className="card-header p-2" id={`heading${index}`}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0">
                                                <button className="btn btn-link btn-sm p-0 text-decoration-none" type="button" data-toggle="collapse" data-target={`#collapse${index}`} aria-expanded="true" aria-controls={`collapse${index}`}>
                                                    {dec.mes} - {getTipoDeclaracion(dec.tipo)}
                                                </button>
                                            </h6>
                                            {dec.pagada ?
                                                <span className="badge badge-success">Pagada</span> :
                                                <span className="badge badge-danger">Pendiente</span>
                                            }
                                        </div>
                                    </div>
                                    <div id={`collapse${index}`} className="collapse show" aria-labelledby={`heading${index}`} data-parent="#declaracionesAccordion">
                                        <div className="card-body p-2">
                                            <div className="row">
                                                <div className="col-6">
                                                    <p className="mb-1"><strong>Fecha:</strong> {formatDate(dec.fechadeclaracion)}</p>
                                                    <p className="mb-1"><strong>Declarado:</strong> {formatCurrency(dec.montodeclarado)}</p>
                                                    <p className="mb-1"><strong>A Pagar:</strong> {formatCurrency(dec.montoapagar)}</p>
                                                    <p className="mb-1"><strong>Recargo:</strong> {formatCurrency(dec.recargo)}</p>
                                                    <p className="mb-1"><strong>Interés:</strong> {formatCurrency(dec.interes)}</p>
                                                </div>
                                                <div className="col-6">
                                                    <p className="mb-1"><strong>Multa:</strong> {formatCurrency(dec.multa)}</p>
                                                    <p className="mb-1"><strong>Retenciones:</strong> {formatCurrency(dec.retenciones)}</p>
                                                    <p className="mb-1"><strong>Descuento:</strong> {formatCurrency(dec.montodescuento)}</p>
                                                    <p className="mb-1"><strong>Reintegro:</strong> {formatCurrency(dec.reintegro)}</p>
                                                    <p className="mb-1"><strong>Crédito Favor:</strong> {formatCurrency(dec.creditofavor)}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {/* Tarjeta de totales */}
                            <div className="card mt-3">
                                <div className="card-header bg-dark text-white">
                                    <h6 className="mb-0">Totales Anuales</h6>
                                </div>
                                <div className="card-body p-2">
                                    <div className="row">
                                        <div className="col-6">
                                            <p className="mb-1"><strong>Total Declarado:</strong> {formatCurrency(
                                                declaraciones.reduce((sum, dec) => sum + parseFloat(dec.montodeclarado || 0), 0)
                                            )}</p>
                                            <p className="mb-1"><strong>Total a Pagar:</strong> {formatCurrency(
                                                declaraciones.reduce((sum, dec) => sum + parseFloat(dec.montoapagar || 0), 0)
                                            )}</p>
                                            <p className="mb-1"><strong>Total Recargo:</strong> {formatCurrency(
                                                declaraciones.reduce((sum, dec) => sum + parseFloat(dec.recargo || 0), 0)
                                            )}</p>
                                        </div>
                                        <div className="col-6">
                                            <p className="mb-1"><strong>Total Interés:</strong> {formatCurrency(
                                                declaraciones.reduce((sum, dec) => sum + parseFloat(dec.interes || 0), 0)
                                            )}</p>
                                            <p className="mb-1"><strong>Total Multa:</strong> {formatCurrency(
                                                declaraciones.reduce((sum, dec) => sum + parseFloat(dec.multa || 0), 0)
                                            )}</p>
                                            <p className="mb-1"><strong>Total Retenciones:</strong> {formatCurrency(
                                                declaraciones.reduce((sum, dec) => sum + parseFloat(dec.retenciones || 0), 0)
                                            )}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="alert alert-info mt-2">
                            No hay declaraciones para mostrar. Seleccione un comercio y un año.
                        </div>
                    )}
                </div>

                <CatalogoComercio
                    show={mostrarCatalogo}
                    onHideAceptaCatCom={datosClasificador}
                    onHideCancelaCatCom={() => {
                        setMostrarCatalogo(false);
                    }}
                />
            </Modal.Body>
            <Modal.Footer>
                <button
                    ref={btnAcepta}
                    onClick={imprimirDeudaGeneral}
                    className="btn btn-sm btn-primary rounded-pill col-md-2"
                    disabled={activate || declaraciones.length === 0}
                >
                    <i className="fas fa-print">  Imprimir</i>
                </button>
                <button
                    ref={btnCancela}
                    onClick={cancelar}
                    className="btn btn-sm btn-danger rounded-pill col-md-2"
                >
                    <i className="fas fa-window-close"> Cancelar</i>
                </button>
                <button
                    ref={btnSalir}
                    onClick={salir}
                    className="btn btn-sm btn-danger rounded-pill col-md-2"
                >
                    <i className="fa fa-sign-out">  Salir</i>
                </button>
            </Modal.Footer>

            {activate && <Dimmer />}

            {mensaje.mostrar && (
                <Mensaje
                    titulo={mensaje.titulo}
                    texto={mensaje.texto}
                    icono={mensaje.icono}
                    onAceptar={() => setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })}
                />
            )}
        </Modal>
    );
}